import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const StillIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 27;
  const color = props.color || 'black';
  return <Icon name={'still'} size={size} color={color} />;
};

export default React.memo(StillIcon);
